export default [
  {
    title: 'Kezdőlap',
    icon: 'HomeIcon',
    tagVariant: 'light-success',
    route: 'monolit.dashboard',
    roles: 'dashboard',
  },
  {
    title: 'Feladatok',
    icon: 'BriefcaseIcon',
    tagVariant: 'light-success',
    route: 'monolit.global.todo',
    roles: 'todo',
  },
  {
    title: 'Kira',
    icon: 'MessageCircleIcon',
    tagVariant: 'light-primary',
    roles: 'kira',
    route: 'monolit.kira.chat',
  },
  {
    title: 'Email utánkövetés',
    icon: 'MailIcon',
    tagVariant: 'light-primary',
    route: 'monolit.email-followups.launcher',
    roles: 'dashboard',
    developerOnly: true,
  },
  {
    title: 'HR',
    icon: 'UsersIcon',
    tagVariant: 'light-success',
    roles: ['freeday_menu', 'workday_calendar', 'accounting', 'employee_menu', 'credit_menu', 'private_comment'],
    children: [
      {
        title: 'Szabadságok',
        route: 'monolit.freedays.list',
        roles: 'freeday_menu',
      },
      {
        title: 'Munkaszüneti napok',
        route: 'monolit.workdays.calendar',
        roles: 'workday_calendar',
      },
      {
        title: 'Jelenléti ívek',
        route: 'monolit.accounting.year',
        roles: 'accounting',
      },
      {
        title: 'Hitelezés/Vásárlás',
        route: 'monolit.credit.list',
        roles: 'credit_menu',
      },
      {
        title: 'Levonások',
        roles: 'private_comment',
        route: 'monolit.private_comment.list',
      },
      {
        title: 'Alkalmazottak',
        route: 'monolit.employee.list',
        roles: 'employee_menu',
      },
    ],
  },
  {
    title: 'Gépek és eszközök',
    icon: 'TruckIcon',
    tagVariant: 'light-info',
    roles: ['car_menu', 'tankolas_role_tankolo', 'tankolas_role_halado', 'tankolas_role_admin', 'tankolas_km_l_controlling', 'tankolas_import'],
    children: [
      {
        title: 'Járművek',
        route: 'monolit.car.list',
        roles: 'car_menu',
      },
      {
        title: 'Emelő gépek',
        route: 'monolit.lifting-machine.list',
        roles: 'car_menu',
      },
      {
        title: 'Munka gépek',
        route: 'monolit.work-machine.list',
        roles: 'car_menu',
      },
      {
        title: 'Torony daruk',
        route: 'monolit.tower-crane.list',
        roles: 'car_menu',
      },
      {
        title: 'Aggregátor',
        route: 'monolit.aggregator.list',
        roles: 'car_menu',
      },
      {
        title: 'Km/ l kontroling',
        route: 'monolit.km-l-controlling.dashboard',
        roles: 'tankolas_km_l_controlling',
      },
      {
        title: 'Tankolás import',
        itemClass: 'km-import-item',
        route: 'monolit.km-l-controlling.list',
        roles: 'tankolas_import',
      },
      {
        title: 'Tankolás rögzítés',
        route: 'monolit.tankolas.record',
        roles: ['tankolas_role_tankolo', 'tankolas_role_halado', 'tankolas_role_admin'],
      },
      {
        title: 'Tartály feltöltés',
        route: 'monolit.tankolas.refill',
        roles: ['tankolas_role_tankolo', 'tankolas_role_halado', 'tankolas_role_admin'],
      },
      {
        title: 'Tankolás gépek',
        route: 'monolit.tankolas.machines',
        roles: ['tankolas_role_halado', 'tankolas_role_admin'],
      },
      {
        title: 'Gépkezelők',
        route: 'monolit.tankolas.operators',
        roles: ['tankolas_role_halado', 'tankolas_role_admin'],
      },
    ],
  },
  {
    title: 'Pénzügy',
    icon: 'DollarSignIcon',
    tagVariant: 'light-success',
    roles: 'invoice_progress',
    children: [
      {
        title: 'Számlák',
        roles: 'invoice_progress',
        route: 'monolit.invoice.list',
      },
    ],
  },
  {
    title: 'Projektek',
    icon: 'BriefcaseIcon',
    tagVariant: 'light-info',
    roles: ['subcontractor', 'foreman_my_projects', 'project', 'additional_work_create', 'prep_view_all', 'prep_assign_project', 'prep_view_own', 'accounting'],
    children: [
      {
        title: 'Alvállakozók',
        roles: 'subcontractor',
        route: 'monolit.subcontractor.list',
      },
      {
        title: 'Megrendelők',
        roles: 'subcontractor',
        route: 'monolit.client.list',
      },
      {
        title: 'Projektjeim',
        route: 'monolit.foreman.projects.list',
        roles: 'foreman_my_projects',
      },
      {
        title: 'Projektek',
        roles: 'project',
        route: 'monolit.projects.list',
      },
      {
        title: 'Pótmunka rögzítése',
        roles: 'additional_work_create',
        route: 'monolit.projects.additional_work_create',
      },
      {
        title: 'Ajánlati lista',
        roles: 'project',
        route: 'monolit.project.total.offers',
      },
      {
        title: 'IFC betöltő',
        route: 'monolit.projects.bim-ifc-import',
        roles: 'project',
        developerOnly: true,
      },
      {
        title: 'Előkészítés',
        roles: ['prep_view_all', 'prep_assign_project', 'prep_view_own'],
        route: 'monolit.preparation.list',
      },
    ],
  },
  {
    title: 'Vezetői',
    icon: 'BarChartIcon',
    tagVariant: 'light-success',
    roles: ['report', 'accounting'],
    children: [
      {
        title: 'Riportok',
        roles: 'report',
        route: 'monolit.report.list',
      },
      {
        title: 'Kontrolling',
        roles: 'report',
        route: 'monolit.controlling.dashboard',
      },
      {
        title: 'Létszám menedzsment',
        route: 'monolit.accounting.workforce-planning',
        roles: 'accounting',
        developerOnly: true,
      },
    ],
  },
  {
    title: 'Rendelések',
    icon: 'BoxIcon',
    tagVariant: 'light-info',
    roles: 'order_menu',
    children: [
      {
        title: 'Rendeléseim',
        route: 'monolit.order.own',
        roles: 'create_order',

      },
      {
        title: 'Létrehozás',
        route: 'monolit.order.create',
        roles: 'create_order',
      },
      {
        title: 'Rendelések',
        route: 'monolit.order.list.list',
        roles: 'progress_order',
      },
      {
        title: 'Számlák',
        route: 'monolit.order.invoice.list',
        roles: 'invoices_offer',
      },
    ],
  },
  {
    title: 'Adminisztráció',
    icon: 'SettingsIcon',
    tagVariant: 'light-info',
    roles: ['user', 'viber', 'extra_fields'],
    children: [
      {
        title: 'Felhasználók',
        roles: 'user',
        route: 'monolit.user.list',
      },
      {
        title: 'Viber beállítások',
        roles: 'viber',
        route: 'monolit.viber.settings',
      },
      {
        title: 'Extra mezők',
        route: 'monolit.extrafields.list',
        roles: 'extra_fields',
      },
    ],
  },
]
